<template>
  <CPanel>
    <HeroChart
      ref="hero-chart"
      name="dashboard-chart"
      :data="chartData"
      :date-range="{ start: currentConditions.start, end: currentConditions.end }"
      :granularity="currentConditions.granularity"
      selectable-category
      :categories="categories"
      :conditions="currentPreferences"
      :min-date="minDate"
      :max-date="maxDate"
      action-menu
      data-table
      :currency="currency"
      is-on-dashboard
      @update-preferences="updatePreferences"
      @update-date-range="onUpdateDateRange"
      @change-granularity="onUpdateGranularity"
      @change-category="onUpdateCategory"
      @change-setting-success="onChangeSettingSuccess({ owner, ownerId })"
      :loading="loading"
    >
      <template v-slot:filters-prepend v-if="getResourceTypes.length > 1">
        <CSection>
          <CTitle class="mb-xs">{{ $t('Resource type') }}</CTitle>

          <CSelector
            :options="resourceTypeOptions"
            v-model="currentResourceType"
            map-options
            emit-value
            :use-input="false"
            hide-bottom-space
          />
        </CSection>

        <CSeparator spaced />
      </template>
    </HeroChart>
  </CPanel>
</template>

<script>
import heroChartMixin from './heroChartMixin';
import chartLang from '@/components/CustomCharts/lang';

import CTitle from '@/components/uikit/CTitle';
import CSection from '@/components/uikit/CSection';
import CSelector from '@/components/uikit/CSelector';
import CSeparator from '@/components/uikit/CSeparator';
import CPanel from '@/components/uikit/CPanel';

import HeroChart from '@/components/CustomCharts/HeroChart';

const messages = {
  en: {
    // Chart common lang
    ...chartLang.en,

    'Resource type': 'Resource type',
  },
  ja: {
    // Chart common lang
    ...chartLang.ja,

    'Resource type': 'リソースタイプ',
  },
};

export default {
  name: 'Chart',
  i18n: { messages },
  mixins: [heroChartMixin],
  components: {
    CTitle,
    CSection,
    CSelector,
    CSeparator,
    CPanel,
    HeroChart,
  },
};
</script>

<style lang="scss" scoped>
.company-id .value {
  color: $neutral-color;
}
</style>
